import { useNavigate } from "react-router-dom";
import Nav from "./Nav.jsx";
import Footer from "./Footer.jsx";
import "./home.css";
import StandardExpressList from "../Components/ListpageExpress";
import { bMEDisposalRequests } from "../HelperFx/datalinks.js";
import verifyToken from "../HelperFx/verifyJwt.js";

const REACT_UNAME = process.env.REACT_APP_API_USERNAME;
const REACT_PWD = process.env.REACT_APP_API_PASSWORD;
const REACT_DATA_URL = process.env.REACT_APP_API_DATA_URL;
const REACT_APP_COMPANY_URL = process.env.REACT_APP_COMPANY;

const DisposalRequests = () => {
  const navigate = useNavigate();
  const token = btoa(`${REACT_UNAME}:${REACT_PWD}`);
  const { custName } = verifyToken(sessionStorage.getItem("authToken")) || {};
  const apiUrl = `${REACT_DATA_URL}${bMEDisposalRequests}?${REACT_APP_COMPANY_URL}&$filter=customerNo eq '${custName}'`;

  const columns = [
    {
      name: "No.",
      selector: (row) => (
        <span
          style={{ color: "blue", cursor: "pointer", textDecoration: "underline" }}
          onClick={() =>
            navigate("/DisposalRequest", { state: { number: row.no } })
          }
        >
          {row.no}
        </span>
      ),
      sortable: true,
    },
    { name: "Machine Type", selector: (row) => row.machineType, sortable: true },
    { name: "Machine No", selector: (row) => row.machineNo, sortable: true },
    { name: "Machine Name", selector: (row) => row.machine, sortable: true },
    {
      name: "Maintenance Type",
      selector: (row) => row.maintenanceType,
      sortable: true,
    },
    {
      name: "Disposal Reason",
      selector: (row) => row.disposalReason,
      sortable: true,
    },
    { name: "Status", selector: (row) => row.status, sortable: true },
  ];

  return (
    <div className="Home">
      <Nav />
      <div className="dash-main settings-full">
        <StandardExpressList
          apiUrl={apiUrl}
          token={token}
          columns={columns}
          searchKeys={["no", "machineNo", "machine", "status", "disposalReason"]}
          pageCaption="Disposal Requests"
          actionvisibility={false}
          redirectTo="home"
          infiniteScroll
        />
      </div>
      <Footer />
    </div>
  );
};

export default DisposalRequests;
